/* eslint-disable */
import React from 'react';
import LoaderGraphic from '../../utils/LoaderGraphic';
import PRAnalysis from '../PRAnalysis';
import MoneyReportSheets from '../report_components/MoneyReportSheets';
import DashboardViewControls from '../utils/DashboardViewControls';
import ParentDashboard from '../ParentDashboard';
import { getDashBoardPagesPDF } from '../PDFDashboardHelper';
import TextEditor from '../TextEditor';
import TextEditorPDF from '../TextEditorPDF';
import moment from 'moment';


const PracticeReport = React.forwardRef((props, ref) => {
  const navbar = window.navbar.navbar;

    const CoverPage = () => {
        const reportTitle = 'Practice Report';
        const todayDate = moment(Date.now()).format('LL');
        const firmName = props.data.firm_name;
        const firmLogo = props.data.firm_logo;

        return (
            <div className="portrait-view cover-page-pdf">
                <div className="cover-page-top-section" />
                <div className="cover-page-info">
                    <div>
                    <div className="img-title-page-print">
                        {firmLogo ? <img src={firmLogo} alt="" /> : null}
                    </div>
                    <h1>{reportTitle}</h1>
                    <div className="cp-report-info">
                        <p>{firmName}</p>
                        <p style={{ textTransform: 'uppercase' }}>{todayDate}</p>
                    </div>
                    </div>
                </div>
                <div className="cover-page-bottom-section">
                    <p>Powered by Peerview Data</p>
                </div>
            </div>
        );
    }

  const getReportComponent = (tab, pdf = false) => {
    switch (tab.report) {
        case 'cover_page':
            return <CoverPage key="cover_page" />;
            break;
        case 'client-analysis':
            return (
                <PRAnalysis
                    {...props.data}
                    tab='client-analysis'
                    pdf={pdf}
                    handleFocusedClients={props.handleFocusedClients}
                    handleTableChanges={props.handleTableChanges}
                    naicsString={props?.data?.selected_filters?.naics_string || props?.selectedFilters?.naics_string}
                    selectedFilters={props.selectedFilters}
                    setSelectedFilters={props.setSelectedFilters}
                    tableState={props.tableState}
                    user_focused_clients={props.data.user_focused_clients}
                />
            );
            break;
        case 'pnl':
            return (
                <MoneyReportSheets
                    pdf={pdf}
                    clientName={'Practice Report'}
                    commonKey='revenue'
                    filters={props.selectedFilters}
                    n={props.data.child_count}
                    page={'practice'}
                    sheet='pnl'
                    title='Profit &#38; Loss'
                    tree={props.data.tree}
                    year={props.data.year}
                    yearRange={props.data.yearRange}
                    calcs={props.data.report_metrics}
                />
            )
            break;
        case 'balance-sheet':
            return (
                <MoneyReportSheets
                    pdf={pdf}
                    clientName={'Practice Report'}
                    commonKey='assets'
                    filters={props.selectedFilters}
                    n={props.data.child_count}
                    page={'practice'}
                    sheet='balance_sheet'
                    title='Balance Sheet'
                    tree={props.data.tree}
                    year={props.data.year}
                    yearRange={props.data.yearRange}
                    calcs={props.data.report_metrics}
                />
            )
            break;
        case 'dashboard':
            if (pdf) {
                const dashboardPages = getDashBoardPagesPDF(props.dashboard.layout);
                return dashboardPages.map((dashboardItems, index) => (
                    <div key={`practice-dashboard-pdf-${index}`} className='portrait-view'>
                      <div className='money-pdf-portrait'>
                        <div>
                          <ParentDashboard
                            clientData={props.data.focusedClientData}
                            calculations={props.data.dashboard_calculations}
                            rankingData={props.data.rankingData}
                            dashboardLayout={dashboardItems}
                            handleOnLayoutChange={props.handleOnLayoutChange}
                            handleToggleDraggable={props.handleToggleDraggable}
                            page={'practice'}
                            year={props.data.year}
                            yearRange={props.data.yearRange}
                            pdf
                          />
                        </div>
                      </div>
                    </div>
                ))
            }

            return (
                 <>
                    {props.activeTab === 'dashboard' && (
                        <DashboardViewControls
                            report={'practice'}
                            noMultipleViews={true}
                            dashboardViewModalState={props.dashboardViewModalState}
                            getDashBoardView={props.getDashBoardView}
                            handleDashboardViewModal={props.handleDashboardViewModal}
                        />
                    )}
                    {props.activeTab === 'dashboard' && (
                        <ParentDashboard
                            pdf={pdf}
                            clientData={props.data.focusedClientData}
                            calculations={props.data.dashboard_calculations}
                            rankingData={props.data.rankingData}
                            dashboardLayout={props.dashboard.layout || []}
                            handleOnLayoutChange={props.handleOnLayoutChange}
                            handleToggleDraggable={props.handleToggleDraggable}
                            page={'practice'}
                            year={props.data.year}
                            yearRange={props.data.yearRange}
                        />
                    )}
                 </>
            )
            break;
        case 'practice_notes':
            if (props.pdf) {
                const companyNote = props.companyNotes.find(n => n?.preference_id === tab?.id) || { notes: '' };
                return (
                    <TextEditorPDF
                        key={`${tab.key}-pdf`}
                        companyNotes={companyNote}
                    />
                )
            } else {
                const companyNote = props.companyNotes.find(n => n?.preference_id === tab?.id) || { notes: '' };
                return (
                    <TextEditor
                        key={`${tab.key}-${props.companyNotes.length}`}
                        tabInfo={tab}
                        companyNotes={companyNote}
                        onChangeNotes={props.onChangeNotes}
                        page={'practice'}
                    />
                )
            }
            break;
        default:
            break;
    }
  }

  if (props.pdf) {
    return (
        <div ref={ref} className='pdf-print-container'>
            {props.displayPages.filter((tab) => tab.checked).map((tab) => getReportComponent(tab, true))}
        </div>
    )
  }

  const renderAllReports = () => {
    return (
        props.reportsOnTabs.map((tab) => {
            if (tab.key === 'dashboard') {
                return <React.Fragment key="dashboard">{getReportComponent(tab)}</React.Fragment>;
            }
            return (
                <div
                    key={tab.key}
                    className={props.activeTab === tab.key ? 'show-section' : 'hide-section'}
                >
                    {getReportComponent(tab)}
                </div>
            );
        })
    )
  }


  if (props.data.year > 0) {
    return (
      <div style={{ opacity: (props.isLoading ? 0.6 : 1) }}>
        <div className='money-content'>
          {props.data.insufficientData
            ? <h1>{props.data.insufficientData}</h1>
            : renderAllReports()
          }
        </div>
      </div>
    )
  } else {
    return (
      <div style={{ 'height': '80vh', 'paddingTop': '30vh' }}>
        <LoaderGraphic />
      </div>
    )
  }
});

export default PracticeReport;

// <div className={props.activeTab === 'naics-trend-number' ? 'show-section' : 'hide-section'}>
//   <TrendChart
//     key='naics-trend-number'
//     type='number'
//     naics_trends_data={props.data.naics_trends_data}
//     year={props.data.year}
//   />
// </div>
// <div className='page-break' />
// <div className={props.activeTab === 'naics-trend-dollars' ? 'show-section' : 'hide-section'}>
//   <TrendChart
//     key='naics-trend-dollars'
//     type='dollars'
//     naics_trends_data={props.data.naics_trends_data}
//     year={props.data.year}
//   />
// </div>
// <div className='page-break' />